import React, {Component} from "react";
import {connect} from "react-redux";
import Objects from "../../redux/Objects";
import Loading from "../shared/Loading";
import {history} from "../../history/History";
import Timer from "../utils/Timer";
import {activate, forgotPassword, forgotPasswordSubmit, profile, sendCodeAgain} from "../../utils/API";
import {set} from "../../redux/Action";
import {sessionAddMulti} from "../../history/Session";
import InputMaterial from "../shared/InputMaterial";
import logo from "../../images/logo-white.png";

class SendCode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendCodeApi: false,
            sendCodeRepeatApi: false,
            password: '',
            repeatPassword: '',
            timer: 120,
            code1: '',
            code2: '',
            code3: '',
            code4: '',
        }
    }

    componentDidMount() {

    }

    setPassword(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 32)
            return
        this.setState({
            password: evt.target.value,
        })
    }

    setRepeatPassword(evt) {
        evt.preventDefault();
        if (evt.target.value.length === 32)
            return
        this.setState({
            repeatPassword: evt.target.value,
        })
    }

    sendCodeRepeat = () => {
        this.setState({sendCodeRepeatApi: true})
        if (this.props.sendCode.type === 'register') {
            sendCodeAgain(this.props.sendCode.username, (res) => {
                this.setState({sendCodeRepeatApi: false, timer: this.state.timer + 1})
            }, () => {
                this.setState({sendCodeRepeatApi: false, timer: this.state.timer + 1})
            })
        } else
            forgotPassword(this.props.sendCode.usernameEmail, (res) => {
                this.setState({sendCodeRepeatApi: false})
            }, () => {
                this.setState({sendCodeRepeatApi: false})
            })
    }

    activate = () => {
        let code = this.state.code1 + this.state.code2 + this.state.code3 + this.state.code4
        if (code.length !== 4) {
            return
        }

        if (this.props.sendCode.type === 'register') {
            this.setState({sendCodeApi: true})
            activate(this.props.sendCode.email, code, (res) => {
                this.props.dispatch(set(Objects.token, res.token))
                profile((res2) => {
                    this.props.dispatch(set(Objects.profile, res2))
                    this.props.dispatch(set(Objects.tutorEnv, res2.tutor))
                    let params = {
                        [Objects.token]: res.token,
                        [Objects.profile]: res2,
                        [Objects.tutorEnv]: res2.tutor,
                    }
                    sessionAddMulti(params)
                    window.sessionLoaded = true
                    window.userLogin = true
                    history.push("/hom")
                })
                this.setState({sendCodeApi: false})
            }, (res) => {
                this.setState({sendCodeApi: false})
            })
        } else {
            if (this.state.password.length < 4 ||
                this.state.password !== this.state.repeatPassword) {
                return
            }
            this.setState({sendCodeApi: true})
            forgotPasswordSubmit(this.props.sendCode.usernameEmail, code, this.state.password, (res) => {
                this.setState({sendCodeApi: false})
                history.push("/hom/login")
            }, (res) => {
                this.setState({sendCodeApi: false})
            })
        }
    }

    clearCode1() {
        this.setState({code1: ''})
    }

    clearCode2() {
        this.setState({code2: ''})
    }

    clearCode3() {
        this.setState({code3: ''})
    }

    clearCode4() {
        this.setState({code4: ''})
    }

    setCode1(evt) {
        if (evt.target.value === 2)
            return
        this.setState({code1: evt.target.value})
        this.refs.code2.focus()
    }

    setCode2(evt) {
        if (evt.target.value === 2)
            return
        this.setState({code2: evt.target.value})
        this.refs.code3.focus()
    }

    setCode3(evt) {
        if (evt.target.value === 2)
            return
        this.setState({code3: evt.target.value})
        this.refs.code4.focus()
    }

    setCode4(evt) {
        if (evt.target.value === 2)
            return
        this.setState({code4: evt.target.value})
        this.refs.code4.blur()
    }

    render() {
        return (this.props.sendCode ?
                (<div className="contain-app">
                    <div className="logo">
                        <img alt="logo" src={logo}/>
                    </div>
                    <div className="body-login">
                        <div>
                            {this.props.sendCode.type === 'register' && <h5>Verify your email</h5>}
                            <div className="mb-3">
                        <span
                            style={{'fontSize': '13px'}}>{'Code was sent to your email'}</span>
                                <button className="mr-1 grey-text" onClick={() => {
                                    history.goBack()
                                }}>{this.props.sendCode.type === 'register' ? 'Change Email' : 'Return'}
                                </button>
                            </div>
                            {this.props.sendCode.type === 'forgotPassword' &&
                            <span className="d-block mb-1">Code</span>}
                            <div className="send-code">
                                <input value={this.state.code4}
                                       ref="code4"
                                       type="tel"
                                       onChange={this.setCode4.bind(this)}
                                       onFocus={this.clearCode4.bind(this)}/>
                                <input value={this.state.code3}
                                       ref="code3"
                                       type="tel"
                                       onChange={this.setCode3.bind(this)}
                                       onFocus={this.clearCode3.bind(this)}/>
                                <input value={this.state.code2}
                                       ref="code2"
                                       type="tel"
                                       onChange={this.setCode2.bind(this)}
                                       onFocus={this.clearCode2.bind(this)}/>
                                <input value={this.state.code1}
                                       ref="code1"
                                       type="tel"
                                       onChange={this.setCode1.bind(this)}
                                       onFocus={this.clearCode1.bind(this)}/>
                            </div>
                            {this.props.sendCode.type === 'forgotPassword' && <div className="mb-4">
                                <InputMaterial id="password"
                                               type="password"
                                               valid={this.state.password.length === 0 ? undefined : (this.state.password.length > 3)}
                                               value={this.state.password}
                                               title="New Password"
                                               wrongMsg={"Password must be at least 4 characters"}
                                               onChange={(evt) => this.setPassword(evt)}
                                />
                                <InputMaterial id="repeatPassword"
                                               type="password"
                                               valid={this.state.password === this.state.repeatPassword}
                                               value={this.state.repeatPassword}
                                               title="Confirm password"
                                               wrongMsg={"The two passowrds do not match"}
                                               onChange={(evt) => this.setRepeatPassword(evt)}
                                />
                            </div>}
                            <button className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                    disabled={this.state.sendCodeApi} onClick={this.activate}>
                                <Loading show={this.state.sendCodeApi}>
                                    <span>{this.props.sendCode.type === 'register' ? 'Confirm' : 'Change password'}</span>
                                </Loading>
                            </button>
                            <div className="mt-5 text-center">
                                <Timer extraText="Remaining time to resend the code" second={this.state.timer}>
                                    <button className="waves-effect waves-light btn-large white w-100 no-uppercase bold"
                                            style={{width: '150px'}}
                                            disabled={this.state.sendCodeRepeatApi} onClick={this.sendCodeRepeat}>
                                        <Loading show={this.state.sendCodeRepeatApi}>
                                            <span>Resend code</span>
                                        </Loading>
                                    </button>
                                </Timer>
                            </div>
                        </div>
                    </div>

                </div>) : (<div/>)
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    }
}

const mapStateToProps = (state) => {
    return {
        sendCode: state.param[Objects.sendCode],
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SendCode)
